import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreUserProfileToken,
} from '../firestore/UserProfileToken/schema'
import { DateTime } from 'luxon'

export class UserProfileToken extends ObservableModelWithDecorators<FirestoreUserProfileToken> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreUserProfileToken>
  ) {
    super(repository, doc)
  }

  /**
   * returns true token is not consumed and created within the last year
   * if token is eligible for consumption, also returns the time in milliseconds until it expires
   */
  isEligibleForConsumption(now: DateTime): {
    eligible: boolean
    expiresInMS: number
  } {
    // no createdAt say expiresNow
    if (!this.data.createdAt) return { eligible: false, expiresInMS: 0 }

    const expiresInMS =
      DateTime.fromJSDate(this.data.createdAt).plus({ years: 1 }).toMillis() -
      now.toMillis()

    const eligible = !this.isEmpty && !this.data.consumed && expiresInMS > 0

    return { eligible, expiresInMS }
  }
}
